import { LogOut, UserCircle2 } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { useAuth } from '../../hooks/useAuth';

function isGuest(value: unknown): boolean {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') return value !== '0' && value.toLowerCase() !== 'false';
  return false;
}

export function ProfilePage() {
  const { user, logout } = useAuth();

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">Профиль</h1>

      <Card className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-bg-soft text-brand-primary">
            <UserCircle2 size={26} />
          </div>
          <div className="min-w-0">
            <p className="text-base font-medium">{user?.name ?? '—'}</p>
            {isGuest(user?.isGuest) && (
              <Badge variant="info">Гостевой аккаунт</Badge>
            )}
          </div>
        </div>

        {user?.email && (
          <div>
            <p className="text-xs font-medium uppercase tracking-wide text-text-muted">
              Email
            </p>
            <p className="text-sm">{user.email}</p>
          </div>
        )}

        <p className="text-xs text-text-muted">
          Данные профиля подтягиваются из сессии. Расширенные настройки (смена
          имени, API-ключ) появятся, когда бэк откроет соответствующие
          эндпоинты.
        </p>
      </Card>

      <Button
        variant="secondary"
        leftIcon={<LogOut size={16} />}
        onClick={() => void logout()}
      >
        Выйти из аккаунта
      </Button>
    </div>
  );
}
